<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <!--<app-pagetitle title="Tableau de bord"></app-pagetitle>-->
      <app-search-form [allowSavedViews]="true"
        (search)="onSearch($event)"
        [formFields]="formFields"
        [showResultsCount]="false"
      ></app-search-form>
    </div>
  </div>
</div>

<app-gridster-widgets
  [widgets]="widgets"
  [options]="options"
  (layoutSaved)="saveLayout()"
></app-gridster-widgets>


<ng-template #folderTemplate let-row>
  <a
    (click)="goToFolder(row.company ? row.company.id : null)"
    class="text-decoration text-primary d-inline-flex align-items-center"
    [title]="row.company ? row.company.name : 'Dossier sans nom'"
    style="transition: color 0.2s; cursor: pointer"
  >
    <span class="text-truncate" style="max-width: 120px">{{ 
      row.company ? row.company.name : "Dossier sans nom" 
    }}</span>
  </a>
</ng-template>

<!-- Template pastille statut tâche -->
<ng-template #companyIconTemplate let-row>
  <button 
    class="btn btn-link p-0 task-status-badge" 
    [class.task-status-badge-disabled]="isTaskDisabled(row.task) || row.isTaskDone"
    [style.background-color]="getTaskStatusColor(row.task)"
    [style.color]="getTaskStatusTextColor(row.task)"
    (click)="row.openDurationModal ? row.openDurationModal(row) : null; $event.stopPropagation()"
    [title]="row.isTaskDone ? 'Tâche terminée' : (isTaskDisabled(row.task) ? 'Non applicable' : 'Valider la tâche')"
  >
    {{ getTaskStatusName(row.task) }}
  </button>
</ng-template>

<!-- Template utilisateur modifié selon la 3ème photo -->
<ng-template #userTemplate let-row>
  <div class="d-inline-flex align-items-center">
    @if (row.assigneeUser) {
      <app-collaborator-button
        [collaborator]="row.assigneeUser"
        [showIcon]="true"
        iconClass="bi bi-person-fill"
        buttonClass="user-badge"
        [maxLength]="20"
        (collaboratorClick)="onAssigneeClick($event)"
      >
      </app-collaborator-button>
    } @else if (row.user) {
      <span class="collaborator-button user-badge">
        <i class="bi bi-person-fill me-1"></i>
        <span class="collaborator-name">{{ row.user }}</span>
      </span>
    }
  </div>
</ng-template>

<!-- Template pour les actions des tâches -->
<ng-template #actionTemplate let-row>
  <div class="d-flex align-items-center gap-1 action-icons">
    <button class="btn btn-link p-0 me-1" title="Modifier" (click)="openTaskEditModal(row.task); $event.stopPropagation()">
      <i class="fas fa-edit"></i>
    </button>
    <button class="btn btn-link p-0 me-1" title="Replanifier" (click)="openAssigneeModal(row.task); $event.stopPropagation()">
      <i class="bi bi-arrow-repeat"></i>
    </button>
    @if (canDeleteTask(row.task)) {
      <button class="btn btn-link p-0 text-danger" title="Supprimer" (click)="deleteTask(row.task); $event.stopPropagation()">
        <i class="bi bi-trash"></i>
      </button>
    }
  </div>
</ng-template>